<div class="container-box shadow-none" style="background: #fbfbff">
  <div class="p-3">
    <div class="row">
      <div class="col-md-8">
        <form [formGroup]="form" [formEditablePermission]="form" class="step_1_form">
          <div class="row">
            <div class="col-sm-12">
              <mat-form-field2 class="mat-block company-name-block">
                <mat-label>
                  <ng-container i18n>Company Name</ng-container>
                  <i
                    matTooltip="Company Name, this will update the Company Name on the Vrbo info page."
                    matTooltipPosition="above"
                    i18n-matTooltip
                    class="fal fa-question-circle"
                  ></i
                ></mat-label>
                <input type="text" formControlName="companyName" matInput required />
                <mat-error *ngIf="form.get('companyName').touched && form.get('companyName').hasError('required')">
                  <ng-container i18n>Company Name is required</ng-container>
                </mat-error>
                <mat-error *ngIf="form.get('companyName').touched && form.get('companyName').hasError('minlength')">
                  <ng-container i18n>Company Name must be at least 2 characters long</ng-container>
                </mat-error>
                <mat-error *ngIf="form.get('companyName').touched && form.get('companyName').hasError('maxlength')">
                  <ng-container i18n>Company Name must be at most 30 characters long</ng-container>
                </mat-error>
              </mat-form-field2>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <mat-form-field2 class="mat-block" *ngIf="currentCurrency as item">
                <mat-label>
                  <ng-container i18n>Currency</ng-container>
                  <i
                    matTooltip="We use currency set on your account for Vrbo listings"
                    matTooltipPosition="above"
                    i18n-matTooltip
                    class="fal fa-question-circle"
                  ></i>
                </mat-label>
                <input type="text" matInput [value]="item.code" disabled readonly />
                <span matSuffix [innerHtml]="item.symbol"></span>
              </mat-form-field2>
            </div>

            <div class="col-sm-4">
              <mat-form-field2 class="mat-block">
                <mat-label>
                  <ng-container i18n>Primary Guest Minimum Age</ng-container>
                  <i
                    matTooltip="Set the minimum age requirement of the primary renter for your Vrbo listings"
                    matTooltipPosition="above"
                    i18n-matTooltip
                    class="fal fa-question-circle"
                  ></i
                ></mat-label>

                <input type="number" formControlName="primaryGuestMinAge" matInput />
                <mat-error
                  *ngIf="form.get('primaryGuestMinAge').touched && form.get('primaryGuestMinAge').hasError('required')"
                >
                  <ng-container i18n>Age is required</ng-container>
                </mat-error>
              </mat-form-field2>
            </div>
            <div class="col-sm-4">
              <label class="mb-3">
                <ng-container i18n>Booking Settings</ng-container>
                <i
                  matTooltip="Instant Booking is an online booking type that allows travelers to instantly book your property. It also confirms booking requests automatically"
                  matTooltipPosition="above"
                  i18n-matTooltip
                  class="fal fa-question-circle"
                ></i>
              </label>

              <app-form-switch [formControl]="form.get('instantBooking')" class="booking-settings-toggle">
                <ng-container i18n *ngIf="!!form.get('instantBooking').value">Instant</ng-container>
                <ng-container i18n *ngIf="!form.get('instantBooking').value">Request to book</ng-container>
                <i
                  *ngIf="form.get('instantBooking').disabled"
                  matTooltip="Only instant bookings are supported at the moment"
                  matTooltipPosition="above"
                  i18n-matTooltip
                  class="fal fa-question-circle"
                ></i>
              </app-form-switch>
            </div>
          </div>
        </form>
        <div i18n class="text-danger" *ngIf="!stripeCheckbox.checked">
          You must have a Stripe payment gateway connected in order to connect VRBO
        </div>

        <form [formGroup]="termsForm" [formEditablePermission]="form">
          <div class="mb-2 d-flex align-items-center justify-content-between">
            <div class="text-semi-bold">
              <ng-container i18n>Payment Terms</ng-container>
              <i
                matTooltip="Setting up a payment schedule allows you to specify the payment amount you require from your traveler to confirm a booking. You are able to require 100% at the time of booking or set up multiple payments that can be scheduled for future dates."
                matTooltipPosition="above"
                i18n-matTooltip
                class="fal fa-question-circle"
              ></i>
            </div>
            <app-form-switch #stripeCheckbox [value]="isStripeConnected$ | async" [disabled]="true" [inline]="true">
              <ng-container i18n *ngIf="stripeCheckbox.checked">Stripe Connected</ng-container>
              <ng-container i18n *ngIf="!stripeCheckbox.checked">Stripe Not Connected</ng-container>
            </app-form-switch>
          </div>

          <table class="table bg-white rounded shadow" formArrayName="terms">
            <thead class="bg-default2">
              <tr>
                <th class="text-semi-bold" i18n>Days</th>
                <th class="text-semi-bold" i18n>Payment Time</th>
                <th class="text-semi-bold" i18n>Percent (%)</th>
                <th class="text-center text-semi-bold" i18n>Remove</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of terms.controls; let i = index" [formGroup]="terms.controls[i]">
                <td>
                  <ng-container *ngIf="hasDays(item['controls'].type.value)">
                    <mat-form-field2 class="mat-block" [showLabel]="false">
                      <input
                        type="number"
                        formControlName="days"
                        matInput
                        required
                        placeholder="Days"
                        i18n-placeholder
                      />
                    </mat-form-field2>
                  </ng-container>
                </td>
                <td>
                  <mat-form-field2 class="mat-block" [showLabel]="false">
                    <input
                      type="text"
                      [value]="getTypeLabel(item['controls'].type.value)"
                      matInput
                      disabled
                      required
                      placeholder="Payment time"
                      i18n-placeholder
                    />
                  </mat-form-field2>
                </td>
                <td>
                  <mat-form-field2 class="mat-block" [showLabel]="false">
                    <input
                      type="text"
                      formControlName="percent"
                      matInput
                      required
                      placeholder="Percent"
                      i18n-placeholder
                    />
                  </mat-form-field2>
                </td>
                <td class="text-center">
                  <button
                    class="btn btn-light-danger"
                    (click)="onRemoveTerm(i)"
                    [disabled]="1 | isReadonlyRole"
                    type="button"
                  >
                    <i class="cs-icon cs-icon-trash"></i>
                  </button>
                </td>
              </tr>
              <tr
                [formGroup]="termForm"
                *ngIf="
                  canAddMoreTypes(terms.controls) &&
                  remainingPercentage?.length > 0 &&
                  remainingTypes?.length > 0 &&
                  (isStripeConnected$ | async)
                "
              >
                <td>
                  <div *ngIf="hasDays(termForm.get('type').value)">
                    <mat-form-field2 class="mat-block" [showLabel]="false">
                      <input
                        type="number"
                        formControlName="days"
                        matInput
                        required
                        placeholder="Days"
                        i18n-placeholder
                      />
                      <mat-error *ngIf="termForm.get('days').touched && termForm.get('days').hasError('required')">
                        <ng-container i18n>Days is required</ng-container>
                      </mat-error>
                      <mat-error *ngIf="termForm.get('days').touched && termForm.get('days').hasError('min')">
                        <ng-container i18n>Days must be a positive number</ng-container>
                      </mat-error>
                    </mat-form-field2>
                  </div>
                </td>
                <td>
                  <mat-form-field2 class="mat-block" [showLabel]="false">
                    <mat-select
                      matTooltip="Choose when the payment should be made"
                      matTooltipPosition="above"
                      i18n-matTooltip
                      formControlName="type"
                      placeholder="Payment time"
                      i18n-placeholder
                    >
                      <mat-option *ngFor="let t of remainingTypes" [value]="t.value">
                        {{ t.label }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="termForm.get('type').touched && termForm.get('type').hasError('required')">
                      <ng-container i18n>Type is required</ng-container>
                    </mat-error>
                  </mat-form-field2>
                </td>
                <td>
                  <mat-form-field2 class="mat-block" [showLabel]="false">
                    <mat-select formControlName="percent" placeholder="Percent" i18n-placeholder>
                      <mat-option *ngFor="let t of remainingPercentage" [value]="t"> {{ t }} %</mat-option>
                    </mat-select>
                    <mat-error *ngIf="termForm.get('percent').touched && termForm.get('percent').hasError('required')">
                      <ng-container i18n>Percent is required</ng-container>
                    </mat-error>
                  </mat-form-field2>
                </td>
                <td class="text-center pb-4">
                  <button
                    (click)="onAddTerm()"
                    [disabled]="1 | isReadonlyRole"
                    type="button"
                    class="btn btn-secondary-info"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-sm-12">
            <div class="text-semi-bold mb-3">
              <ng-container i18n>Cancellation Policy</ng-container>
              <i
                matTooltip="When setting your listing’s cancellation policy, you may choose from one of seven options."
                matTooltipPosition="above"
                i18n-matTooltip
                class="fal fa-question-circle"
              ></i>
            </div>

            <mat-radio-group [formControl]="form.get('cancellationPolicy')" class="cancellation-group">
              <ul class="list-group">
                <li class="list-group-item">
                  <mat-radio-button value="STRICT">
                    <div class="d-flex gap-2 align-items-center">
                      <div class="badge badge-circle badge-secondary-warning" style="--size: 2rem">
                        <i class="cs-icon text-md cs-icon-bed-times"></i>
                      </div>
                      <div>
                        <div class="radio-title text-semi-bold" i18n>Strict</div>
                        <div i18n class="radio-desc text-light text-wrap text-sm">
                          Cancel your booking at least 60 days before the stay to get a full refund.
                        </div>
                      </div>
                    </div>
                  </mat-radio-button>
                </li>
                <li class="list-group-item">
                  <mat-radio-button value="FIRM">
                    <div class="d-flex gap-2 align-items-center">
                      <div class="badge badge-circle badge-secondary-primary" style="--size: 2rem">
                        <i class="cs-icon text-md cs-icon-money-back"></i>
                      </div>
                      <div>
                        <div i18n class="radio-title text-semi-bold">Firm</div>
                        <div i18n class="radio-desc text-light text-wrap text-sm">
                          Cancel at least 60 days before the stay for a full refund. Cancel at least 30 days before for
                          a 50% refund.
                        </div>
                      </div>
                    </div>
                  </mat-radio-button>
                </li>
                <li class="list-group-item">
                  <mat-radio-button value="MODERATE">
                    <div class="d-flex gap-2 align-items-center">
                      <div class="badge badge-circle badge-secondary-indigo" style="--size: 2rem">
                        <i class="cs-icon text-md cs-icon-dollar-back"></i>
                      </div>
                      <div>
                        <div i18n class="radio-title text-semi-bold">Moderate</div>
                        <div class="radio-desc text-light text-wrap text-sm">
                          <span class="text-success" i18n>Recommended</span>
                          <ng-container i18n
                            >- Cancel at least 30 days before the stay for a full refund. Cancel at least 14 days before
                            for a 50% refund.</ng-container
                          >
                        </div>
                      </div>
                    </div>
                  </mat-radio-button>
                </li>
                <li class="list-group-item">
                  <mat-radio-button value="RELAXED">
                    <div class="d-flex gap-2 align-items-center">
                      <div class="badge badge-circle badge-secondary-success" style="--size: 2rem">
                        <i class="cs-icon text-md cs-icon-relax"></i>
                      </div>
                      <div>
                        <div class="radio-title text-semi-bold" i18n>Relaxed</div>
                        <div i18n class="radio-desc text-light text-wrap text-sm">
                          Cancel at least 14 days before the stay for a full refund. Cancel at least 7 days before for a
                          50% refund.
                        </div>
                      </div>
                    </div>
                  </mat-radio-button>
                </li>
                <li class="list-group-item">
                  <mat-radio-button value="LENIENT">
                    <div class="d-flex gap-2 align-items-center">
                      <div class="badge badge-circle badge-secondary-info" style="--size: 2rem">
                        <i class="cs-icon text-md cs-icon-calendar-check"></i>
                      </div>
                      <div>
                        <div class="radio-title text-semi-bold" i18n>Lenient</div>
                        <div i18n class="radio-desc text-light text-wrap text-sm">
                          Cancel at least 5 days before the stay for a full refund.
                        </div>
                      </div>
                    </div>
                  </mat-radio-button>
                </li>
                <li class="list-group-item">
                  <mat-radio-button value="DAY_BEFORE">
                    <div class="d-flex gap-2 align-items-center">
                      <div class="badge badge-circle badge-secondary-info" style="--size: 2rem">
                        <i class="cs-icon text-md cs-icon-calendar-day"></i>
                      </div>
                      <div>
                        <div class="radio-title text-semi-bold" i18n>Day-before</div>
                        <div i18n class="radio-desc text-light text-wrap text-sm">
                          Cancel at least 24 hours before check-in for a full refund.
                        </div>
                      </div>
                    </div>
                  </mat-radio-button>
                </li>
                <li class="list-group-item">
                  <mat-radio-button value="NO_REFUND">
                    <div class="d-flex gap-2 align-items-center">
                      <div class="badge badge-circle badge-secondary-danger" style="--size: 2rem">
                        <i class="cs-icon text-md cs-icon-money-ban"></i>
                      </div>
                      <div>
                        <div class="radio-title text-semi-bold" i18n>No Refund</div>
                        <div i18n class="radio-desc text-light text-wrap text-sm">
                          No refunds will be offered, regardless of the reason or timeframe.
                        </div>
                      </div>
                    </div>
                  </mat-radio-button>
                </li>
              </ul>
            </mat-radio-group>
          </div>
        </div>
      </div>
    </div>
    <div class="alert alert-secondary-warning2 mt-3">
      <i class="cs-icon cs-icon-alert-triangle2 alert-icon"></i>
      <div class="alert-content">
        <div class="text-bold"
             i18n>Important</div>
        <div>
          <ng-container i18n>Invoicing must be done entirely within AdvanceCM — including creating and processing invoices.
            A connected Stripe account is required. You can set up</ng-container>&nbsp;
          <a href="https://advance.cm/help/article/invoice-automations"
             target="_blank"
             i18n>invoice automations</a>&nbsp;
          <ng-container i18n>to automate payment collection.</ng-container>
        </div>
      </div>
    </div>

  </div>
  <div class="border-top p-4 mt-5 d-flex align-items-center gap-3">
    <button class="btn btn-outline-light" (click)="prev.emit()">
      <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
      <ng-container i18n>Previous</ng-container>
    </button>
    <div class="flex-fill"></div>
    <button (click)="onDisconnect()" type="button" class="btn btn-secondary-danger" *ngIf="!!config?.status">
      <i class="fal fa-ban"></i> <ng-container i18n>Disconnect</ng-container>
    </button>
    <button
      (click)="onReconnect()"
      [disabled]="!(isStripeConnected$ | async)"
      type="button"
      class="btn btn-secondary-info"
      *ngIf="!!config && !config?.status"
    >
      <i class="fal fa-link"></i> <ng-container i18n>Connect</ng-container>
    </button>
    <button
      (click)="onContinue()"
      [disabled]="!(isStripeConnected$ | async)"
      type="button"
      *ngIf="!config || !!config?.status"
      class="btn btn-secondary-info"
    >
      <ng-container i18n>Next</ng-container>
      <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
    </button>
  </div>
</div>
